class Device {
  static ua = typeof window !== 'undefined' ? window.navigator.userAgent : '';

  static isIos = Device.ifIos();
  static isAndroid = Device.ifAndroid();
  static isMobile = Device.ifMobile();
  static isPc = Device.ifPc();
  static isMac = Device.ifMac();
  static isWechat = Device.ifWechat();
  static wechatVersion = Device.getWechatVersion();

  static ifIos() {
    return /iphone|ipad|ipod/i.test(this.ua);
  }

  static ifAndroid() {
    return /android/i.test(this.ua);
  }

  static ifMobile() {
    return /mobile/i.test(this.ua) || this.isIos || this.isAndroid;
  }

  static ifPc() {
    return !this.isMobile;
  }

  static ifMac() {
    return /Macintosh/i.test(this.ua);
  }

  static ifWechat() {
    return /MicroMessenger/i.test(this.ua);
  }

  static getWechatVersion() {
    const version = this.ua.match(/MicroMessenger\/([\d\.]*)/i);
    return (version && version[1]) || '';
  }
}

export default Device;
